import { FC } from 'react';

import { getCustomFormat } from '@monoimin/utils/formatters';

interface TimeTagProps extends React.HTMLAttributes<HTMLTimeElement> {
  date?: string;
}

export const TimeTag: FC<TimeTagProps> = ({ date, ...props }) => {
  const format = getCustomFormat('en');
  // здесь мы форматируем дату и передаем в атрибут datetime
  const formattedDate = date ? format(new Date(date), 'YYYY-MM-DD') : undefined;
  const timeProps = {
    dateTime: formattedDate,
  };

  return (
    <time {...timeProps} {...props}>
      {date}
    </time>
  );
};
